export const Sizes = {
  Tablet: "1000px",
  Mobile: "600px",
};

export const MediaQueries = {
  Tablet: `@media screen and (max-width: ${Sizes.Tablet})`,
  Mobile: `@media screen and (max-width: ${Sizes.Mobile})`,
};
